import { gsap } from '../global/gsap';
import vars from '../global/vars';

const initWorkFilter = (filter) => {
    const filterToggle = filter.querySelector('.js-filter-toggle');
    const filterButtons = filter.querySelectorAll('.js-filter-btn');
    const viewToggles = filter.querySelectorAll('.js-view-toggle');
    const workAll = document.querySelector('.js-work-all');
    const workCards = workAll.querySelectorAll('.js-card');
    const workFeatured = document.querySelector('.js-work-featured');
    const initialUrl = new URL(window.location.href);
    const urlParams = initialUrl.searchParams.get('filter');
    const { body } = vars;

    let filterActive = false;
    let toggleTl;
    let working = false;

    let mm = gsap.matchMedia();

    mm.add('(min-width: 900px)', () => {
        const stickyTl = gsap.timeline({
            scrollTrigger: {
                trigger: filter,
                start: 'top 70px',
                onEnter: () => filter.classList.add('is-sticky'),
                onLeaveBack: () => filter.classList.remove('is-sticky'),
            },
        });

        toggleTl = gsap.timeline({ paused: true });
        toggleTl.from(filterButtons, {
            yPercent: 75,
            duration: 0.3,
            stagger: -0.05,
            ease: 'power2.inOut',
        });

        return () => {
            stickyTl.kill();
            if (toggleTl) toggleTl.kill();
            filter.classList.remove('is-sticky');
            gsap.set(filterButtons, { clearProps: 'all' });
        };
    });

    const toggleWorking = (state) => {
        working = state !== undefined ? state : !working;
        body.classList.toggle('working', working);
    };

    const toggleFilter = () => {
        filterActive = !filterActive;
        filter.classList.toggle('filter-active', filterActive);

        if (toggleTl) {
            filterActive ? toggleTl.play() : toggleTl.reverse();
        }
    };

    filterToggle.addEventListener('click', toggleFilter);

    const toggleView = (view, skipWorkingToggle = false) => {
        if (!skipWorkingToggle) toggleWorking(true);
        if (view === 'all') {
            gsap.to(workFeatured, {
                autoAlpha: 0,
                duration: 0.3,
                onComplete: () => {
                    gsap.set(workFeatured, { display: 'none' });
                    gsap.set(workAll, { display: 'grid' });
                    gsap.to(workAll, {
                        autoAlpha: 1,
                        duration: 0.3,
                        onComplete: () => {
                            toggleWorking(false);
                        },
                    });
                },
            });
        } else {
            // Reset the filter
            filterCards('', true);
            filterButtons.forEach((button) => {
                button.classList.remove('is-active');
            })
            gsap.to(workAll, {
                opacity: 0,
                duration: 0.3,
                onComplete: () => {
                    gsap.set(workAll, { display: 'none' });
                    gsap.set(workFeatured, { display: 'grid' });
                    gsap.to(workFeatured, {
                        autoAlpha: 1,
                        duration: 0.3,
                        onComplete: () => {
                            toggleWorking(false);
                        },
                    });
                },
            });
        }
    };

    viewToggles.forEach((toggle) => {
        const { type } = toggle.dataset;
        toggle.addEventListener('click', () => {
            if (toggle.classList.contains('is-active') || working) return;

            // Clear any existing queryparams
            const cleanUrl = window.location.origin + window.location.pathname;
            window.history.replaceState(null, '', cleanUrl);

            viewToggles.forEach((btn) => {
                btn.classList.remove('is-active');
            });
            toggle.classList.add('is-active');
            toggleView(type);
        });
    });

    const filterCards = (filters) => {
        toggleWorking(true);
        const activeCards = [];

        workCards.forEach((card) => {
            const cats = card.dataset.cats ? card.dataset.cats.split(',') : [];
            const isMatch =
                filters.length === 0 ||
                cats.some((cat) => filters.includes(cat));
            if (isMatch) {
                activeCards.push(card);
            }
        });

        if (activeCards && activeCards.length > 0) {
            gsap.to(workCards, {
                autoAlpha: 0,
                duration: 0.3,
                stagger: {
                    amount: 0.2,
                    from: 'random',
                },
                onComplete: () => {
                    gsap.set(workCards, {
                        display: 'none',
                    });
                    gsap.set(activeCards, {
                        display: 'initial',
                    });
                    gsap.to(activeCards, {
                        autoAlpha: 1,
                        duration: 0.3,
                        stagger: {
                            amount: 0.2,
                            from: 'random',
                            onComplete: () => {
                                toggleWorking(false);
                            },
                        },
                    });
                },
            });
        } else {
            gsap.to(workCards, {
                autoAlpha: 1,
                duration: 0.3,
                onComplete: () => {
                    toggleWorking(false);
                },
            });
        }

        return activeCards;
    };

    const updateUrl = (slug) => {
        const url = new URL(window.location.href);
        const params = url.searchParams;
        const currentString = params.get('filter') || '';
        let filterArray = currentString ? currentString.split(',') : [];

        if (filterArray.includes(slug)) {
            filterArray = filterArray.filter((item) => item !== slug);
        } else {
            filterArray.push(slug);
        }

        if (filterArray.length > 0) {
            params.set('filter', filterArray.join(','));
        } else {
            params.delete('filter');
        }

        window.history.replaceState({}, '', url);
        return filterArray;
    };

    filterButtons.forEach((button) => {
        const { slug } = button.dataset;
        button.addEventListener('click', () => {
            if (working) return;
            button.classList.toggle('is-active');
            const activeFilters = updateUrl(slug);

            // Set view toggle classes
            viewToggles.forEach((btn) => {
                if (btn.dataset.type === 'all') {
                    btn.classList.add('is-active');
                } else {
                    btn.classList.remove('is-active');
                }
            });

            if (workAll.style.display === 'grid') {
                filterCards(activeFilters);
            } else {
                filterCards(activeFilters);
                toggleView('all', true);
            }
        });
    });

    if (urlParams) {
        const activeSlugs = urlParams.split(',');

        filterButtons.forEach((btn) => {
            if (activeSlugs.includes(btn.dataset.slug)) {
                btn.classList.add('is-active');
            }
        });

        workCards.forEach((card) => {
            const cats = card.dataset.cats ? card.dataset.cats.split(',') : [];
            const isMatch = cats.some((cat) => activeSlugs.includes(cat));
            if (isMatch) {
                gsap.set(card, { autoAlpha: 1, display: 'initial' });
            } else {
                gsap.set(card, { autoAlpha: 0, display: 'none' });
            }
        });

        gsap.set(workFeatured, { autoAlpha: 0, display: 'none' });
        gsap.set(workAll, { autoAlpha: 1, display: 'grid' });

        viewToggles.forEach((btn) => {
            btn.classList.toggle('is-active', btn.dataset.type === 'all');
        });
    }
};

export default initWorkFilter;
